import { useState } from 'react';
import { Stack, Text, VStack, HStack, Switch } from '@chakra-ui/react';
import { FormControl, FormLabel } from 'components/v4';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const AppAuthSelectiveSyncField = ({
    onChange,
    isDisabled,
    isChecked,
    darkMode,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Stack>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Selective Sync
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enable selective sync of users and data.
                    </Text>
                </Stack>
                <Stack flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal" marginTop="20px">
                        <HStack spacing={3} alignItems="center">
                            <Switch
                                isChecked={isChecked}
                                isDisabled={isDisabled}
                                onChange={(e) => onChange(e.target.checked)}
                                colorScheme="whatsapp"
                                name="selectiveSync"
                            />
                            <FormLabel
                                sx={{ marginBottom: '6px !important' }}
                                fontSize="sm"
                                display="flex"
                                alignItems="center">
                                Enable Selective Sync
                            </FormLabel>
                        </HStack>
                    </VStack>
                </Stack>
                {isHovered && (
                    <FieldToolTip
                        label="Enable to selectively synchronize users and data based on filters"
                        ariaLabel="selective-sync-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default AppAuthSelectiveSyncField;
